import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'reactstrap';

const ContactContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-image: url('https://www.eea.europa.eu/highlights/eight-facts-about-europe2019s-forest-ecosystems/image_print');
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  overflow: hidden;
  padding: 6rem 0;

  @media (min-width: 961px) {
    background-attachment: fixed;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    z-index: 0;
  }

  h2 {
    font-size: 2rem;
    margin-bottom: 1rem;
    z-index: 1;
    position: relative;
    color: #fff;
  }

  .contact-form {
    label {
      font-size: 1.1rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
      color: #fff;
      z-index: 4;
      display: block;
    }

    input,
    textarea {
      width: 100%;
      padding: 0.75rem 0.5rem;
      border: none;
      border-radius: 0.25rem;
      margin-bottom: 1.5rem;
      font-size: 1.1rem;
      resize: none;
      background: transparent;
      border-bottom: 2px solid #fff;
      color: #fff;
      z-index: 4;

      &:focus {
        outline: none;
        box-shadow: none;
        border-bottom: 2px solid #207216;
      }

      &::placeholder {
        color: rgba(255,255,255,0.7);
      }
    }

    textarea {
      min-height: 140px;
    }

    button {
      padding: 1em 2em;
      border: none;
      border-radius: 5px;
      font-weight: bold;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #154010;
      background-color: #ffffff;
      transition: all 0.3s ease;
      font-size: 15px;
      position: relative;
      overflow: hidden;
      outline: 2px solid #154010;
      cursor: pointer;
    }

    button:hover {
      color: #ffffff;
      transform: scale(1.05);
      outline: 2px solid #114426;
      box-shadow: 4px 5px 17px -4px #114426;
      background-color: #114426;
    }

    button:disabled {
      opacity: 0.7;
      cursor: not-allowed;
      transform: none;
    }
  }

  .contact-info {
    margin-top: 2rem;

    h2 {
      margin-bottom: 2rem;
    }

    p {
      font-size: 1.1rem;
      line-height: 1.8;
      color: #fff;
      margin-bottom: 1rem;
    }
  }

  .container {
    z-index: 5;
    position: relative;
  }

  strong {
    color: white;
  }

  .popup {
    position: fixed;
    top: 30px;
    right: 30px;
    padding: 1rem 1.5rem;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
    z-index: 999;
    font-weight: bold;
    animation: fadeIn 0.3s ease;
  }

  .popup.success {
    color: #207216;
    border-left: 5px solid #207216;
  }

  .popup.error {
    color: #d32f2f;
    border-left: 5px solid #d32f2f;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 4rem 1rem;

    .popup {
      right: 15px;
      left: 15px;
      top: 15px;
    }
  }
`;

function Contact() {
  const [isSending, setIsSending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  useEffect(() => {
    const handleTouchStart = () => {
      setIsPopupVisible(false);
    };

    window.addEventListener('touchstart', handleTouchStart);

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
    };
  }, []);

  const sendEmail = async (e) => {
    e.preventDefault();

    if (isSending) return;

    setIsSending(true);

    const formData = new FormData(e.target);

    // Wklej tutaj swój access key z Web3Forms
    formData.append(
      'access_key',
      'c00d6d57-245f-4462-9e99-a3a063a61542'
    );

    formData.append(
      'subject',
      'Nowa wiadomość ze strony Eko Zakątek'
    );

    try {
const response = await fetch('https://api.web3forms.com/submit', {
  method: 'POST',
  body: formData,
});

const raw = await response.text();

console.log('RAW:', raw);

const success = raw.includes('"success":true');

if (success) {
  setIsSuccess(true);
  e.target.reset();
} else {
  setIsSuccess(false);
}
    } catch (error) {
      console.log(error);
      setIsSuccess(false);
    }

    setIsSending(false);
    setIsPopupVisible(true);

    setTimeout(() => {
      setIsPopupVisible(false);
    }, 3000);
  };

  return (
    <ContactContainer>
      <Container>
        <Row>
          <Col md="6">
            <div className="contact-form">
              <h2>Napisz do nas!</h2>

              <form onSubmit={sendEmail}>
                <div>
                  <label htmlFor="name">Imię</label>

                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Twoje imię"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="email">E-mail</label>

                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="twoj@email.pl"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="message">Wiadomość</label>

                  <textarea
                    id="message"
                    name="message"
                    placeholder="Napisz swoją wiadomość..."
                    required
                  />
                </div>

                {/* Anti spam */}
                <input
                  type="checkbox"
                  name="botcheck"
                  style={{ display: 'none' }}
                />

                <button type="submit" disabled={isSending}>
                  {isSending ? 'Wysyłanie...' : 'Wyślij'}
                </button>
              </form>
            </div>
          </Col>

          <Col md="6">
            <div className="contact-info">
              <h2>Dane Kontaktowe</h2>

              <p>
                <strong>Adres:</strong><br />
                ul. Aloesowa 8 i 10<br />
                34-324 Ostre
              </p>

              <p>
                <strong>Email:</strong><br />
                kontakt@eko-zakatek.pl
              </p>

              <p>
                <strong>Telefon:</strong><br />
                +48 606 992 351
              </p>

              <p>
                <strong>Godziny:</strong><br />
                Pon-Pt, 9:00 - 17:00
              </p>
            </div>
          </Col>
        </Row>
      </Container>

      {isPopupVisible && (
        <div className={`popup ${isSuccess ? 'success' : 'error'}`}>
          {isSuccess
            ? 'Wiadomość została wysłana!'
            : 'Wystąpił błąd. Spróbuj ponownie.'}
        </div>
      )}
    </ContactContainer>
  );
}

export default Contact;